import React from 'react';

type CopyGuardProps = {
  children: React.ReactNode;
};

/**
 * 콘텐츠 무단 복사 방지 래퍼.
 * 드래그 선택과 클립보드 복사/잘라내기를 차단한다 (사람의 수동 복사만 차단 — 크롤러/검색엔진은 영향 없음).
 */
export const CopyGuard = ({ children }: CopyGuardProps) => {
  const handleBlockClipboard = (e: React.ClipboardEvent<HTMLDivElement>) => e.preventDefault();

  return (
    <div className="select-none" onCopy={handleBlockClipboard} onCut={handleBlockClipboard}>
      {children}
    </div>
  );
};
